import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface DemoRequestContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const DemoRequestContext = createContext<DemoRequestContextValue | null>(null);

export function DemoRequestProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <DemoRequestContext.Provider value={{ isOpen, open, close }}>
      {children}
    </DemoRequestContext.Provider>
  );
}

export function useDemoRequest() {
  const ctx = useContext(DemoRequestContext);
  if (!ctx) {
    throw new Error("useDemoRequest must be used within DemoRequestProvider");
  }
  return ctx;
}